import CatalogueThumbnail from 'url:../images/catalogue.png'
import PentestThumbnail from 'url:../images/pentest.png'
import SfeThumbnail from 'url:../images/sfe.png'

type PngImport = string | { default: string }

type App = {
  title: string
  description?: string
  thumbnail?: PngImport
  href: string | undefined
  app_id: string
  notif_href?: string
}

type Features = {
  showOnlyEnabledApps: boolean
}

type StatusMessage = {
  type: 'info' | 'error' | 'warning' | 'success'
  message: string
}

export const APPS: { [key: string]: App } = {
  'app:sfe': {
    title: 'Secure File Exchange',
    description: 'Create repositories and share files',
    thumbnail: SfeThumbnail,
    href: process.env.CSP_SFE_BASE_URL,
    app_id: 'SFE',
    notif_href: `${process.env.CSP_ID_BASE_URL}/notifications/sfe`,
  },
  'app:pentest': {
    title: 'Pentest Service',
    description: 'Upload reports and manage findings',
    thumbnail: PentestThumbnail,
    href: process.env.CSP_PENTEST_BASE_URL,
    app_id: 'Pentest',
    notif_href: `${process.env.CSP_ID_BASE_URL}/notifications/pentest`,
  },
  'app:catalogue': {
    title: 'Service Requests',
    description: 'Submit and track service requests',
    thumbnail: CatalogueThumbnail,
    href: process.env.CSP_CATALOGUE_BASE_URL,
    app_id: 'Catalogue',
    notif_href: `${process.env.CSP_ID_BASE_URL}/notifications/catalogue`,
  },
}

export const IDENTITY_ADMIN_APP = 'app:identity_admin'

export const ADMIN_APPS: { [key: string]: App } = {
  [IDENTITY_ADMIN_APP]: {
    title: 'Identity Admin Portal',
    href: process.env.CSP_ID_ADMIN_BASE_URL,
    app_id: 'identity_admin',
  },
}

export const STATUS_MESSAGES: { [key: string]: StatusMessage } = {
  insufficientPermissions: {
    type: 'info',
    message: "You don't have permissions to view this page.",
  },
  serverError: {
    type: 'error',
    message: 'An error occurred. Please try again.',
  },
}

export const FEATURES: Features = {
  showOnlyEnabledApps: JSON.parse(
    process.env.CSP_PORTAL_FEATURE_SHOW_ONLY_ENABLED_APPS || 'false',
  ),
}
